export const categories = ['All', 'Creative', 'Operations', 'Knowledge', 'Other'];

const thumb = (url) => `https://api.microlink.io/?url=${encodeURIComponent(url)}&screenshot=true&meta=false&embed=screenshot.url`;

export const appsData = [
  {
    id: 1,
    title: 'Editor',
    label: 'Create & transcribe',
    description: 'Transcribe recordings,generate content with AI,and access studio-built creative tools.',
    category: 'Creative',
    tags: ['AI', 'Transcription', 'Content'],
    searchTerms: ['copy', 'writing', 'audio', 'transcript', 'generation'],
    icon: 'Edit3',
    iconColor: '#c493a7',
    url: 'https://editor.vicinity.sg',
    domain: 'editor.vicinity.sg',
    owner: 'Creative Technology',
    thumbnail: thumb('https://editor.vicinity.sg'),
  },
  {
    id: 4,
    title: 'Vault',
    label: 'Search video footage',
    description: 'Find footage in the Vicinity Vimeo library using AI-powered search and discovery.',
    category: 'Creative',
    tags: ['Video', 'Search', 'Footage'],
    searchTerms: ['vimeo', 'clips', 'film', 'library', 'archive'],
    icon: 'Film',
    iconColor: '#9eafba',
    url: 'https://vault.vicinity.sg',
    domain: 'vault.vicinity.sg',
    owner: 'Post-production',
    thumbnail: thumb('https://vault.vicinity.sg'),
  },
  {
    id: 9,
    title: 'Brands',
    label: 'Find brand assets',
    description: 'Download approved logos,typography,colour systems,and identity guidelines.',
    category: 'Creative',
    tags: ['Brand', 'Assets', 'Guidelines'],
    searchTerms: ['logos', 'fonts', 'colours', 'templates', 'identity'],
    icon: 'Feather',
    iconColor: '#dda282',
    url: 'https://brands.vicinity.studio',
    domain: 'brands.vicinity.studio',
    owner: 'Design',
    thumbnail: thumb('https://brands.vicinity.studio'),
  },
  {
    id: 14,
    title: 'Tracker',
    label: 'Plan & track projects',
    description: 'Plan work,monitor delivery milestones,and coordinate projects across teams.',
    category: 'Operations',
    tags: ['Projects', 'Planning', 'Teams'],
    searchTerms: ['tasks', 'timeline', 'delivery', 'status', 'work'],
    icon: 'CheckSquare',
    iconColor: '#82bdce',
    url: 'https://tracker.vicinity.sg',
    domain: 'tracker.vicinity.sg',
    owner: 'Operations',
    recentlyAdded: true,
    thumbnail: thumb('https://tracker.vicinity.sg'),
  },
  {
    id: 15,
    title: 'Desk',
    label: 'Book a desk',
    description: 'Reserve a hot desk,shared workspace,or office facility for your working day.',
    category: 'Operations',
    tags: ['Workspace', 'Facilities', 'Booking'],
    searchTerms: ['hot desk', 'seat', 'office', 'room', 'workspace'],
    icon: 'MapPin',
    iconColor: '#dc9168',
    url: 'https://desk.vicinity.sg',
    domain: 'desk.vicinity.sg',
    owner: 'Facilities',
    thumbnail: thumb('https://desk.vicinity.sg'),
  },
  {
    id: 2,
    title: 'Finance',
    label: 'Manage studio finances',
    description: 'Review budgets and reports,manage invoices,and track studio expenses.',
    category: 'Operations',
    tags: ['Budgets', 'Invoices', 'Reports'],
    searchTerms: ['expenses', 'claims', 'payments', 'money', 'purchase'],
    icon: 'DollarSign',
    iconColor: '#91ba99',
    url: 'https://finance.vicinity.sg',
    domain: 'finance.vicinity.sg',
    owner: 'Finance',
    thumbnail: thumb('https://finance.vicinity.sg'),
  },
  {
    id: 16,
    title: 'Freelancers',
    label: 'Freelancer finance',
    description: 'Open the freelancers area of Vicinity Finance.',
    category: 'Operations',
    tags: ['Freelancers', 'Finance', 'People'],
    searchTerms: ['freelance', 'contractors', 'finance', 'freelancers'],
    icon: 'Users',
    iconColor: '#91ba99',
    url: 'https://finance.vicinity.sg/freelancers',
    domain: 'finance.vicinity.sg/freelancers',
    owner: 'Finance',
  },
  {
    id: 3,
    title: 'IMS',
    label: 'Equipment & inventory',
    description: 'Find and track studio equipment,inventory,stock levels,and allocated assets.',
    category: 'Operations',
    tags: ['Inventory', 'Equipment', 'Assets'],
    searchTerms: ['camera', 'gear', 'stock', 'checkout', 'hardware'],
    icon: 'Package',
    iconColor: '#9eafba',
    url: 'https://ims.vicinity.sg',
    domain: 'ims.vicinity.sg',
    owner: 'Studio Operations',
    thumbnail: thumb('https://ims.vicinity.sg'),
  },
  {
    id: 5,
    title: 'Archive',
    label: 'Find completed projects',
    description: 'Access long-term storage for completed projects,historical records,and deliverables.',
    category: 'Operations',
    tags: ['Storage', 'Projects', 'Records'],
    searchTerms: ['completed work', 'past project', 'deliverables', 'backup'],
    icon: 'Archive',
    iconColor: '#9eafba',
    url: 'https://archive.vicinity.studio',
    domain: 'archive.vicinity.studio',
    owner: 'IT Team',
    thumbnail: thumb('https://archive.vicinity.studio'),
  },
  {
    id: 7,
    title: 'Y Server',
    label: 'KL working files',
    description: 'Open active project files stored on the Kuala Lumpur studio server.',
    category: 'Operations',
    tags: ['Kuala Lumpur', 'Files', 'Server'],
    searchTerms: ['malaysia', 'kl', 'working files', 'shared drive'],
    icon: 'Server',
    iconColor: '#c493a7',
    url: 'https://y.vicinity.studio',
    domain: 'y.vicinity.studio',
    owner: 'IT Team',
    thumbnail: thumb('https://y.vicinity.studio'),
  },
  {
    id: 11,
    title: 'Handbook',
    label: 'Policies & people guide',
    description: 'Find current company policies,leave guidance,culture,and ways of working.',
    category: 'Knowledge',
    tags: ['Policies', 'Culture', 'People'],
    searchTerms: ['leave', 'holiday', 'benefits', 'hr', 'onboarding', 'rules'],
    icon: 'BookOpen',
    iconColor: '#dc9168',
    url: 'https://handbook.vicinity.studio',
    domain: 'handbook.vicinity.studio',
    owner: 'People Team',
    thumbnail: thumb('https://handbook.vicinity.studio'),
  },
  {
    id: 12,
    title: 'Learn',
    label: 'Older handbook',
    description: 'Previous handbook retained for historical reference. Use Handbook for current policies.',
    category: 'Knowledge',
    tags: ['Reference', 'Legacy', 'Policies'],
    searchTerms: ['old handbook', 'historical', 'deprecated'],
    icon: 'Monitor',
    iconColor: '#9eafba',
    url: 'https://learn.vicinity.studio',
    domain: 'learn.vicinity.studio',
    owner: 'People Team',
    status: 'Older resource',
    legacy: true,
    thumbnail: thumb('https://learn.vicinity.studio'),
  },
  {
    id: 13,
    title: 'Careers',
    label: 'View open roles',
    description: 'Browse current job openings and hiring opportunities across Vicinity.',
    category: 'Other',
    tags: ['Hiring', 'People', 'Jobs'],
    searchTerms: ['vacancies', 'recruitment', 'applications', 'roles'],
    icon: 'Briefcase',
    iconColor: '#9eafba',
    url: 'https://careers.vicinity.sg',
    domain: 'careers.vicinity.sg',
    owner: 'People Team',
    thumbnail: thumb('https://careers.vicinity.sg'),
  },
  {
    id: 10,
    title: 'Booking',
    label: 'Book the studio',
    description: 'Schedule studio spaces and production sessions. Contact Kevin if you need access.',
    category: 'Operations',
    tags: ['Studio', 'Scheduling', 'Booking'],
    searchTerms: ['production', 'shoot', 'room', 'calendar', 'kevin'],
    icon: 'Calendar',
    iconColor: '#c493a7',
    url: 'https://booking.vicinity.sg',
    domain: 'booking.vicinity.sg',
    owner: 'Kevin',
    accessEmail: 'kevin@vicinity.studio',
    status: 'Access required',
    thumbnail: thumb('https://booking.vicinity.sg'),
  },
];